import React from 'react';

interface CopyIconProps {
  size?: number;
  color?: string;
}

/**
 * CopyIcon Component
 * @description A copy/clipboard icon for copy actions
 */
export const CopyIcon: React.FC<CopyIconProps> = ({ 
  size = 20, 
  color = 'currentColor' 
}) => {
  return (
    <svg 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke={color}
      width={size}
      height={size}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
      <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
    </svg>
  );
};

export default CopyIcon;

